// icons
import { MdPeople } from "react-icons/md";

const clientes = {
  id: 'clientes-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'clientes',
      title: 'Clientes',
      type: 'item',
      breadcrumbs: false,
      icon: MdPeople,
      url: '/clientes'
    }
  ]
};

export default clientes;
